export default __webpack_public_path__ + "static/media/city.2b3cf09c.png";